import { jsx as r } from "react/jsx-runtime";
import { useMemo as s } from "react";
import n from "./index.es649.js";
import { useIsTextOverflowing as l } from "@placer-ui/hooks";
import { BodyText as f } from "./index.es505.js";
import { SimpleTooltip as p } from "./index.es127.js";
const d = "badge-component", E = ({ label: o, testId: t = d }) => {
  const { isOverflowing: m, textElmRef: e } = l(), i = s(
    () => /* @__PURE__ */ r("div", { className: n.root, "data-testid": t, children: /* @__PURE__ */ r(f, { size: "small", variant: "semi-bold", isEllipsis: !0, ref: e, children: o }) }),
    [o, t, e]
  );
  return m ? /* @__PURE__ */ r(p, { title: o, children: i }) : i;
};
export {
  d as BADGE_DEFAULT_TESTID,
  E as Badge
};
//# sourceMappingURL=index.es7.js.map
